import { type StudentScheduleSlot } from '../model';

// L2 Data
export const l2_schedule: Array<StudentScheduleSlot> = [
  {
    startTime: new Date('01/01/2024 9:00 AM'),
    endTime: new Date('01/01/2024 9:25 AM'),
    startTimeLabel: '9:00 AM',
    endTimeLabel: '9:25 AM',
    slotLabel: 'slot1',
    interactive: true,
  },
  {
    startTime: new Date('01/01/2024 9:25 AM'),
    endTime: new Date('01/01/2024 9:50 AM'),
    startTimeLabel: '9:25 AM',
    endTimeLabel: '9:50 AM',
    slotLabel: 'slot2',
    interactive: true,
  },
  {
    startTime: new Date('01/01/2024 9:50 AM'),
    endTime: new Date('01/01/2024 10:15 AM'),
    startTimeLabel: '9:50 AM',
    endTimeLabel: '10:15 AM',
    slotLabel: 'slot3',
    interactive: true,
  },
  {
    startTime: new Date('01/01/2024 10:15 AM'),
    endTime: new Date('01/01/2024 10:40 AM'),
    startTimeLabel: '10:15 AM',
    endTimeLabel: '10:40 AM',
    slotLabel: 'slot4',
    interactive: true,
  },
  {
    startTime: new Date('01/01/2024 10:40 AM'),
    endTime: new Date('01/01/2024 11:00 AM'),
    startTimeLabel: '10:40 AM',
    endTimeLabel: '11:00 AM',
    slotLabel: 'Break',
    interactive: false,
  },
  {
    startTime: new Date('01/01/2024 11:00 AM'),
    endTime: new Date('01/01/2024 11:50 AM'),
    startTimeLabel: '11:00 AM',
    endTimeLabel: '11:50 AM',
    slotLabel: 'slot4',
    interactive: true,
    repeatedClass: true,
  },
  {
    startTime: new Date('01/01/2024 11:50 AM'),
    endTime: new Date('01/01/2024 12:30 PM'),
    startTimeLabel: '11:50 AM',
    endTimeLabel: '12:30 PM',
    slotLabel: 'Lunch',
    interactive: false,
  },
  {
    startTime: new Date('01/01/2024 12:30 PM'),
    endTime: new Date('01/01/2024 1:20 PM'),
    startTimeLabel: '12:30 PM',
    endTimeLabel: '1:20 PM',
    slotLabel: 'slot3',
    interactive: true,
    repeatedClass: true,
  },
  {
    startTime: new Date('02/28/2024 1:20 PM'),
    endTime: new Date('02/28/2024 2:10 PM'),
    startTimeLabel: '1:20 PM',
    endTimeLabel: '2:10 PM',
    slotLabel: 'slot2',
    interactive: true,
    repeatedClass: true,
  },
  {
    startTime: new Date('02/28/2024 2:10 PM'),
    endTime: new Date('02/28/2024 3:00 PM'),
    startTimeLabel: '2:10 PM',
    endTimeLabel: '3:00',
    slotLabel: 'slot1',
    interactive: true,
    repeatedClass: true,
  },
];

export const SUBJECT_NAMES = [
  'Math',
  'Science',
  'Reading',
  'Language',
  'Social Studies',
  'Computer Science',
  'Calculus',
  'Statistics',
  'Biology',
  'Chemistry',
  'Physics',
  'Social Science',
  'American History',
  'Economics',
  'Human Geography',
  'Foreign Language',
  'Fast Math',
];

export const MAP_EMPTY_SUBJECT_NAMES: { [key: string]: string } = {
  slot1: 'Math',
  slot2: 'Science',
  slot3: 'Reading',
  slot4: 'Language',
};
